import { useMutation, useQueryClient } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import i18n from '@/i18n'
import { MarketShopCategoryModel, MarketShopSettingsModel } from '@/models'
import { getApiErrorMessage } from '@/utils'

import { getMarketShopSettingsQueryKey } from './get-market-shop-settings'

type EditMarketShopCategory = Omit<MarketShopCategoryModel, 'id'> & {
  // Note: If category is new - it doesn't have id
  id?: number
}

export type UpdateMarketShopSettingsRequest = {
  marketShopId: number
  displayNameForCashPayment?: string
  enablePayByCard?: boolean
  enablePayByCash?: boolean
  tipsEnabled?: boolean
  tips?: number[]
  deliverToMe?: boolean
  businessHours?: MarketShopSettingsModel['businessHours']
  globalTax?: number
  categories: EditMarketShopCategory[]
}

export const updateMarketShopSettings = async (data: UpdateMarketShopSettingsRequest) => {
  const response = await authAPI.put<MarketShopSettingsModel>(
    `/market-shop/settings/${data.marketShopId}`,
    data,
  )
  return response.data
}

export const useUpdateMarketShopSettings = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateMarketShopSettings,
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
    onSuccess: (data, variables) => {
      toastFactory.success(i18n.t('market-shop-dashboard:settings.updateSuccess'))
      queryClient.setQueryData(
        getMarketShopSettingsQueryKey({ marketShopId: variables.marketShopId }),
        data,
      )
    },
  })
}
